import React from 'react';
import { useTranslation } from 'react-i18next';

import { FORM_MODES } from 'Consts/formModes';

import { BaseModal } from '@/libs/shared/ui';

import { ErrorDisplay } from '../shared/components/error-display';
import { CourseForm } from '../shared/course-form';
import type { CourseFormData } from '../shared/types';

type Props = {
  open: boolean;
  onClose: () => void;
  initialData?: Partial<CourseFormData>;
  onSubmit: (submissionData: CourseFormData) => void;
  isLoading?: boolean;
  isSuccess?: boolean;
  error?: string;
  onRetry?: () => void;
};

export const EditCourseModal = ({
  open,
  onClose,
  initialData,
  onSubmit,
  isLoading = false,
  isSuccess = false,
  error,
  onRetry
}: Readonly<Props>) => {
  const { t } = useTranslation();

  const content = error ? (
    <ErrorDisplay error={error} onRetry={onRetry ?? (() => {})} />
  ) : (
    <CourseForm
      mode={FORM_MODES.EDIT}
      onSubmit={onSubmit}
      onCancel={onClose}
      isSubmitSuccess={isSuccess}
      isLoading={isLoading}
      initialData={initialData}
    />
  );

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={t('editCourseModal.title')}
      maxWidth="1200px"
      sx={{
        '& .MuiPaper-root': {
          margin: '-5rem'
        }
      }}
    >
      {content}
    </BaseModal>
  );
};
